import {cn} from '@tempmee/core'
import {type InputHTMLAttributes, type ReactNode, forwardRef} from 'react'
import {
  inputBaseClass,
  inputIconWrapperClass,
  inputTextFieldVariants,
} from './InputTextFieldVariants'

export interface InputTextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  /** Applies error styling (red border + background) */
  isError?: boolean
  /** Icon rendered on the left side of the input */
  leftIcon?: ReactNode
  /** Icon rendered on the right side of the input */
  rightIcon?: ReactNode
  /** Disables the input and dims text to the disabled token color */
  disabled?: boolean
}

export const InputTextField = forwardRef<HTMLInputElement, InputTextFieldProps>(
  ({className, isError, leftIcon, rightIcon, disabled, ...props}, ref) => {
    return (
      <div
        className={cn(
          inputTextFieldVariants(),
          'bg-[#f6f9f8] border-divider',
          isError && 'border-error bg-[rgba(255,128,140,0.16)]',
          disabled && 'bg-action-disabled-background border-divider',
          className,
        )}
      >
        {leftIcon && <span className={inputIconWrapperClass}>{leftIcon}</span>}
        <input ref={ref} className={inputBaseClass} disabled={disabled} {...props} />
        {rightIcon && <span className={inputIconWrapperClass}>{rightIcon}</span>}
      </div>
    )
  },
)

InputTextField.displayName = 'InputTextField'
